import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "py-4 container-fluid" }
const _hoisted_2 = { class: "row gx-4" }
const _hoisted_3 = { class: "col-lg-1 coluna" }
const _hoisted_4 = { class: "coluna-header" }
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rotas, (rota) => {
        return (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.fDate(rota.previsao_inicio)) + "-" + _toDisplayString(_ctx.fDate(rota.previsao_fim)), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rota.Pedidos, (pedido, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(`${_ctx.getClassByStatus(pedido.status_entrega)}`),
              key: index
            }, [
              _createElementVNode("span", {
                style: {"font-size":"14px","cursor":"pointer"},
                onClick: ($event: any) => (_ctx.gotoPedido(pedido))
              }, _toDisplayString(pedido.numero_pedido), 9, _hoisted_5)
            ], 2))
          }), 128))
        ]))
      }), 256))
    ])
  ]))
}